import { Device } from "types/device.types";
import DevicesMap from "components/DevicesMap";
import { default as DevicesListComponent } from "components/DevicesList";
import { EmptyState } from "components/shared/EmptyState";
import { LoadingScreen } from "components/shared/LoadingScreen";
import { MapListContainer } from "styles/devices/devicesList.styles";

interface DevicesMapPanelProps {
  devices: Device[];
  isLoading: boolean;
  selectedDevice: Device | null;
  onDeviceSelect: (device: Device | null) => void;
  emptyMessage: string;
  isLocationSearchActive: boolean;
  onLocationSearch: (lat: number, lng: number, radiusKm: number) => void;
  onClearLocationSearch: () => void;
  canAddDevice: boolean;
  onAddDeviceClick?: () => void;
}

export function DevicesMapPanel({
  devices,
  isLoading,
  selectedDevice,
  onDeviceSelect,
  emptyMessage,
  isLocationSearchActive,
  onLocationSearch,
  onClearLocationSearch,
  canAddDevice,
  onAddDeviceClick,
}: DevicesMapPanelProps) {
  const locationEmpty =
    "No devices found in this area. Try moving the map to explore other locations.";

  return (
    <MapListContainer>
      {devices.length === 0 ? (
        isLoading ? (
          <LoadingScreen message="Loading devices..." />
        ) : (
          <EmptyState
            message={isLocationSearchActive ? locationEmpty : emptyMessage}
            actionLabel={canAddDevice ? "Add Device" : undefined}
            onAction={canAddDevice ? onAddDeviceClick : undefined}
          />
        )
      ) : (
        <DevicesListComponent
          devices={devices}
          isLoading={isLoading}
          selectedDevice={selectedDevice}
          onDeviceSelect={onDeviceSelect}
          viewType="map"
        />
      )}
      <DevicesMap
        devices={devices}
        selectedDevice={selectedDevice}
        onDeviceSelect={onDeviceSelect}
        onLocationSearch={onLocationSearch}
        isLocationSearchActive={isLocationSearchActive}
        onClearLocationSearch={onClearLocationSearch}
      />
    </MapListContainer>
  );
}
